/* A self-contained card component also works after Gecko replaces filtered results. */
if (!customElements.get('prenco-card-colors')) {
  customElements.define('prenco-card-colors', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('[data-color-name]').forEach(swatch => {
        swatch.setAttribute('role', 'button');
        swatch.setAttribute('aria-pressed', String(swatch.classList.contains('is-selected')));
      });
      this.addEventListener('keydown', event => {
        if (event.key === ' ' && event.target.matches('[data-color-name]')) {
          event.preventDefault();
          event.target.click();
        }
      });
      this.addEventListener('click', event => {
        const swatch = event.target.closest('[data-color-name]');
        if (!swatch || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const card = this.closest('.prenco-card');
        if (!card) return;
        event.preventDefault();
        this.querySelectorAll('[data-color-name]').forEach(item => {
          const selected = item === swatch;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        this.querySelector('.prenco-card-colors__selected').textContent = swatch.dataset.colorName;
        card.querySelectorAll('[data-pr-href], a.t4s-pr-addtocart:not([data-action])').forEach(link => { link.href = swatch.href; });
        const image = card.querySelector('.prenco-card__image');
        if (image) {
          if (!image.dataset.defaultSrc) {
            image.dataset.defaultSrc = image.currentSrc || image.src;
            image.dataset.defaultAlt = image.alt;
          }
          // Clear responsive candidates so a previous color cannot override the selection.
          image.removeAttribute('srcset');
          image.src = swatch.dataset.colorImage || image.dataset.defaultSrc;
          image.alt = swatch.dataset.colorImage
            ? `${card.querySelector('.t4s-product-title').textContent.trim()} — ${swatch.dataset.colorName}`
            : image.dataset.defaultAlt;
        }
      });
    }
  });
}
